module.exports = __webpack_public_path__ + "img/23.553ce642.jpg";